"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class AuthereumProvider {
    constructor(instance) {
        this._authereum = instance;
        this._starkProvider = instance.getStarkProvider();
    }
    setContractAddress(contractAddress) {
        this._starkProvider.setContractAddress(contractAddress);
    }
    resolve(payload, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { id, method, params } = payload;
            return this._starkProvider.send(method, params);
        });
    }
    enable(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.requestAccounts();
        });
    }
    updateAccount(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.getStarkKey();
        });
    }
    getActiveAccount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.getStarkKey();
        });
    }
    account(layer, application, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.getStarkKey();
        });
    }
    requestAccounts() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const account = yield this._authereum.getAccountAddress();
            if (account) {
                return [account];
            }
            return [];
        });
    }
    personalSign(message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.starkSignMessage(message);
        });
    }
    registerUser(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { ethKey, operatorSignature } = input;
            return this._starkProvider.registerUser(ethKey, operatorSignature);
        });
    }
    deposit(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.deposit(input);
        });
    }
    withdraw(input, txOpts = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { asset, recipient } = input;
            const assetStandard = asset.type;
            const assetContractAddress = asset.data.tokenAddress;
            const quantum = asset.data.quantum;
            return this._starkProvider.withdraw(assetStandard, quantum, assetContractAddress, recipient);
        });
    }
    transfer(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.transfer(input);
        });
    }
    createOrder(input) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._starkProvider.createOrder(input);
        });
    }
    perpetualTransfer(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('authereum: not implemented');
        });
    }
    perpetualLimitOrder(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('authereum: not implemented');
        });
    }
    perpetualWithdrawal(params) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            throw new Error('authereum: not implemented');
        });
    }
}
exports.default = AuthereumProvider;
//# sourceMappingURL=AuthereumProvider.js.map